import { useTranslation } from 'react-i18next';
import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import { getMemberIconByAge } from '@/common/utils/family-members';
import { CardActionLink } from '@coverflex-tech/hypernova';

interface IProps {
  member: IFamilyMember;
  onClick?: () => void;
}

export const FamilyMemberBox = ({ member, onClick }: IProps) => {
  const { t } = useTranslation();

  return (
    <CardActionLink
      onClick={onClick}
      description={t(
        `dashboard.family_member_details.family_member_type.${member.type}`
      )}
      title={member.shortName}
      icon={getMemberIconByAge(member.birthdate)}
      iconBadgeColor="accentSecondary20"
    />
  );
};
